class EventsInterfaces {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/event`;
    this.apiClient = apiClient;

  }

  async getOrCreateEventTemplate(postId) {

    const path = `${this.basePath}/template`;

    return this.apiClient.post(path, { postId }, {}, {});

  }

  async updateEventTemplateByPostId(postId, update) {

    const path = `${this.basePath}/template`;

    return this.apiClient.put(path, { postId }, {}, update);

  }

  async validateUpdateEventTemplateByPostIdInput(postId, update) {

    const path = `${this.basePath}/template/validate`;

    return this.apiClient.put(path, { postId }, {}, update);

  }

  async getEventByPostId(postId) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, { postId }, {});

  }

  async updateEventByPostId(postId, update) {

    const path = `${this.basePath}`;

    return this.apiClient.put(path, { postId }, {}, update);

  }

  async validateUpdateEventByPostIdInput(postId, update) {

    const path = `${this.basePath}/validate`;

    return this.apiClient.put(path, { postId }, {}, update);

  }

  async cancelEventByPostId(postId) {

    const path = `${this.basePath}/cancel`;

    return this.apiClient.put(path, { postId }, {}, {});

  }

  async createEventRegistration(postId) {

    const path = `${this.basePath}/registrations`;

    return this.apiClient.post(path, { postId }, {}, {});

  }

  async getEventRegistrationsByPostId(postId) {

    const path = `${this.basePath}/registrations`;

    return this.apiClient.get(path, { postId }, {});

  }

  async deleteEventRegistrationByIdAndUserId(postId) {

    const path = `${this.basePath}/registrations`;

    return this.apiClient.delete(path, { postId }, {});

  }

}

export default EventsInterfaces;